import { Typography, Grid2, Box } from "@mui/material";
import pic from "../../../../ui-utils/latestPics/DerivativeHome.svg"
import Styles from "./Web.module.css"
import { motion } from "framer-motion";
import en from "../../../../i18n/English/Trade Invest/derivative.json";
import hi from "../../../../i18n/Hindi/Trade Invest/derivative.json";
import kn from "../../../../i18n/Kannada/Trade Invest/derivative.json";
import ma from "../../../../i18n/Marathi/Trade Invest/derivative.json";
import gu from "../../../../i18n/Gujarati/Trade Invest/derivative.json";
import { useLanguage } from "../../../../Context/LangContext";
export default function BenefitsWeb() {

      const { language } = useLanguage();
      const translations = { en, hi, kn,gu,ma };
      const t = translations[language];
    return (
        <>
            <Grid2 className={Styles.outerBox}>
                <motion.div
                    initial={{ opacity: 0, x: -300 }}   // far off-screen
                    animate={{ opacity: 1, x: 0 }}      // animates into position
                    transition={{ duration: 1, delay: 0.2, ease: "easeInOut" }}
                >

                <Grid2 className={Styles.innerCard}>
                  <div className={Styles.headingContainer}>
                        <div className={Styles.gradientBackground}></div>
                        <Typography className={Styles.heading}>
                            {t.title}
                        </Typography>
                    </div>

                    <Grid2 className={Styles.txtCard}>
                        <Typography className={Styles.innertxt1} >
                            <span className={Styles.innertxtspan}>
                                •
                            </span>
                            <span className={Styles.innertxtWrapper}>
                                    {t.points[0]}
                            </span>
                        </Typography>

                        <Typography className={Styles.innertxt1}>
                            <span className={Styles.innertxtspan}>
                                •
                            </span>
                            <span className={Styles.innertxtWrapper}>
                                    {t.points[1]}
                            </span>
                        </Typography>

                        <Typography className={Styles.innertxt1}>
                            <span className={Styles.innertxtspan}>
                                •
                            </span>
                            <span className={Styles.innertxtWrapper}>
                                    {t.points[2]}
                            </span>
                        </Typography>

                        <Typography className={Styles.innertxt1}>
                            <span className={Styles.innertxtspan}>
                                •
                            </span>
                            <span className={Styles.innertxtWrapper}>
                                    {t.points[3]}
                            </span>
                        </Typography>

                        <Typography className={Styles.innertxt1}>
                            <span className={Styles.innertxtspan}>
                                •
                            </span>
                            <span className={Styles.innertxtWrapper}>
                                    {t.points[4]}
                            </span>
                        </Typography>
                    </Grid2>


                </Grid2>
             </motion.div>

                <motion.div
                    initial={{ opacity: 0, x: 300 }}   // far off-screen
                    animate={{ opacity: 1, x: 0 }}      // animates into position
                    transition={{ duration: 1, delay: 0.2, ease: "easeInOut" }}
                >
                 <img src={pic} alt="equity" className={Styles.pic} />
             </motion.div>
            </Grid2>
        </>
    )
}